// src/services/api.js
import axios from "axios";
import Cookies from "js-cookie";

//const baseURL = 'http://localhost:8000/api';
const baseURL = 'https://api.mercanteomexico.com/api';

const api = axios.create({ baseURL });
const refreshApi = axios.create({ baseURL });

// 👉 Adjunta el token a cada request
api.interceptors.request.use((config) => {
  const accessToken = Cookies.get("accessToken");
  if (accessToken) {
    config.headers["Authorization"] = `Bearer ${accessToken}`;
  }
  return config;
}, (error) => Promise.reject(error));

// 👉 Intenta refrescar si el token expiró
const refreshToken = async () => {
  try {
    const refresh = Cookies.get("refreshToken");
    const response = await refreshApi.post("/token/refresh/", { refresh });
    const newAccessToken = response.data.access;

    Cookies.set("accessToken", newAccessToken, { expires: 1 });
    return newAccessToken;
  } catch (error) {
    console.error("Error al refrescar el token");
    return null;
  }
};

api.interceptors.response.use(
  res => res,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401) {
      const msg = error.response.data?.detail || "";

      if (msg.includes("modificado") || msg.includes("inválido")) {
        Cookies.remove("accessToken");
        Cookies.remove("refreshToken");
        window.location.href = "/";
        return Promise.reject("Sesión cerrada por token modificado");
      }

      if (!originalRequest._retry) {
        originalRequest._retry = true;
        const newAccessToken = await refreshToken();
        if (newAccessToken) {
          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
          return api(originalRequest);
        } else {
          Cookies.remove("accessToken");
          Cookies.remove("refreshToken");
          window.location.href = "/";
          return Promise.reject("No se pudo refrescar el token");
        }
      }
    }

    return Promise.reject(error);
  }
);

export default api;
